import { render, staticRenderFns } from "./ShowHistory.vue?vue&type=template&id=b6b4a50c&scoped=true&"
import script from "./ShowHistory.vue?vue&type=script&lang=js&"
export * from "./ShowHistory.vue?vue&type=script&lang=js&"
import style0 from "./ShowHistory.vue?vue&type=style&index=0&id=b6b4a50c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b4a50c",
  null
  
)

export default component.exports